import React, { useEffect, useRef } from "react";

const GaugeChart = ({ riskScore = 0 }) => {
  const numericRiskScore = Number(riskScore);
  const gaugeRef = useRef(null);

  useEffect(() => {
    if (!window.Highcharts) {
      console.error("Highcharts is not loaded.");
      return;
    }

    const gaugeChart = window.Highcharts.chart(gaugeRef.current, {
      chart: {
        type: "gauge",
        plotBackgroundColor: null,
        plotBackgroundImage: null,
        plotBorderWidth: 0,
        plotShadow: false,
        backgroundColor: "#fbfbfb",
      },
      title: { text: "" },
      navigation: {
        buttonOptions: {
          enabled: false,
        },
      },
      pane: {
        startAngle: -90,
        endAngle: 89.9,
        background: null,
        center: ["50%", "75%"],
        size: "110%",
      },
      yAxis: {
        min: 0,
        max: 100,
        tickPixelInterval: 72,
        tickPosition: "inside",
        tickColor:
          window.Highcharts.defaultOptions.chart.backgroundColor || "#FFFFFF",
        tickLength: 20,
        tickWidth: 2,
        minorTickInterval: null,
        labels: {
          distance: 20,
          style: {
            fontSize: "14px",
          },
        },
        lineWidth: 0,
        plotBands: [
          { from: 0, to: 70, color: "#ed4545", thickness: 30 },
          { from: 60, to: 90, color: "#ff7e00", thickness: 30 },
          { from: 80, to: 100, color: "#42b25a", thickness: 30 },
        ],
      },
      series: [
        {
          name: "Risk",
          data: [numericRiskScore],
          tooltip: { valueSuffix: " " },
          dataLabels: {
            format: "{y}",
            borderWidth: 0,
            color:
              (window.Highcharts.defaultOptions.title &&
                window.Highcharts.defaultOptions.title.style &&
                window.Highcharts.defaultOptions.title.style.color) ||
              "#333333",
            style: { fontSize: "16px" },
          },
          dial: {
            radius: "60%", // Shorter needle (adjust this as needed)
            backgroundColor: "gray",
            baseWidth: 12,
            baseLength: "0%",
            rearLength: "0%",
          },
          pivot: {
            backgroundColor: "gray",
            radius: 6,
          },
        },
      ],
    });

    return () => {
      gaugeChart.destroy(); // Clean up on unmount
    };
  }, [riskScore]);

  return (
    <div
      ref={gaugeRef}
      style={{ width: "200px", height: "200px", margin: "0 auto" }}
    />
  );
};

export default GaugeChart;
